import './style';
import App from './components/app';

// import ChatStore from './state/chatStore';

// const Root = () => <App ChatStore={ChatStore} />;

// export default Root;
export default App;



// WEBPACK FOOTER //
// ./index.js